export class Circle_Marker {
  latitude: number;
  longitude: number;
  radius: number;
  fillColor?: string;
  fillOpacity?: number;
  circleDraggable?: boolean;
  editable?: boolean;
}
